module.exports = function () {
  if (process.env.VUE_APP_MODE) {
    return process.env.VUE_APP_MODE
  } else {
    return 'dev'
  }
}
